<app-theme-toggle></app-theme-toggle>

<!-- Page -->
<div class="flex grow">
	<!-- Header -->
	<header app-header
		class="flex lg:hidden items-center fixed z-10 top-0 start-0 end-0 shrink-0 bg-mono dark:bg-background h-(--header-height)"
		id="header">
	</header>
	<!-- End of Header -->
	<!-- Wrapper -->
	<div class="flex flex-col lg:flex-row grow pt-(--header-height) lg:pt-0">
		<!-- Sidebar -->
		<div app-sidebar class="flex-col fixed top-0 bottom-0 z-20 hidden lg:flex items-stretch shrink-0 w-(--sidebar-width) dark [--kt-drawer-enable:true] lg:[--kt-drawer-enable:false]"
			data-kt-drawer="true" data-kt-drawer-class="kt-drawer kt-drawer-start flex top-0 bottom-0" id="sidebar"
			data-kt-drawer-initialized="true">
		</div>
		<!-- End of Sidebar -->
		<!-- Main -->
		<div class="flex flex-col grow lg:rounded-l-xl bg-background border border-input lg:ms-(--sidebar-width)">
			<div class="flex flex-col grow kt-scrollable-y-auto lg:[--kt-scrollbar-width:auto] pt-5"
				id="scrollable_content">
				<main class="grow" role="content">
					<!-- Toolbar -->
					<div app-toolbar class="pb-5">
					</div>
					<!-- End of Toolbar -->
					<!-- Container -->
					<router-outlet></router-outlet>
					<!-- End of Container -->
				</main>
				<!-- Footer -->
				<footer app-footer class="footer"></footer>
				<!-- End of Footer -->
			</div>
		</div>
		<!-- End of Main -->
	</div>
	<!-- End of Wrapper -->
</div>
<!-- End of Page -->